import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getRelatedBusinesses } from '../../../../../lib/api/business';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../lib/designSystem/Table';
import { showAlert } from '../../../../../lib/functions/utils';
import ConfirmDeleteDialog from './components/ConfirmDeleteDialog';
import CreateRelationDialog from './components/CreateRelationDialog';

interface RelatedBusinessesProps {
  businessIdentifier: string;
}

const RelatedBusinesses = ({ businessIdentifier }: RelatedBusinessesProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [relatedBusinesses, setRelatedBusinesses] = useState<any>([]);
  const [openCreateRelationDialog, setOpenCreateRelationDialog] =
    useState(false);
  const [businessToDelete, setBusinessToDelete] = useState<any>(null);
  const [openConfirmDeleteDialog, setOpenConfirmDeleteDialog] = useState(false);

  const fetchRelatedBusinesses = async () => {
    if (!businessIdentifier) {
      showAlert(dispatch, 'error', 'No se ha encontrado el id de la empresa');
      return;
    }
    const response = await getRelatedBusinesses(dispatch, businessIdentifier);
    setRelatedBusinesses(response);
  };

  const setUp = async () => {
    setLoading(true);
    await fetchRelatedBusinesses();
    setLoading(false);
  };

  const onCloseCreateRelationDialog = async () => {
    setOpenCreateRelationDialog(false);
    await setUp();
  };

  const onCloseConfirmDeleteDialog = async () => {
    setOpenConfirmDeleteDialog(false);
    setBusinessToDelete(null);
    await setUp();
  };

  const buttons: CustomButtonProps[] = [
    {
      name: 'Crear',
      action: () => setOpenCreateRelationDialog(true),
      color: 'primary',
    },
  ];

  const handleDelete = async (identifier: string) => {
    const businessToIdentifier = relatedBusinesses.find(
      (business: any) => business.id === identifier,
    );
    if (!businessToIdentifier) {
      showAlert(dispatch, 'error', 'No se ha encontrado la empresa');
      return;
    }
    setOpenConfirmDeleteDialog(true);
    setBusinessToDelete(businessToIdentifier.id);
  };

  useEffect(() => {
    void setUp();
  }, []);

  const headers = [
    { key: 'businessName', label: 'Nombre' },
    { key: 'businessIdentifier', label: 'Rut' },
  ];

  const actions = [
    {
      action: handleDelete,
      actionLabel: 'Eliminar',
    },
  ];
  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <HeaderWithActions
        variant="body1"
        subHeader
        buttons={buttons}
        title="Acá podrás ver las empresas que están relacionadas a esta empresa."
      />
      <EnhancedTable
        dataHeaders={headers}
        data={relatedBusinesses}
        rowsPerPageDefault={100}
        actions={actions}
      />
      {loading && <CenteredCircularProgress relative />}
      {openCreateRelationDialog && (
        <CreateRelationDialog
          open={openCreateRelationDialog}
          onClose={() => void onCloseCreateRelationDialog()}
          businessFromIdentifier={businessIdentifier}
        />
      )}
      {openConfirmDeleteDialog && (
        <ConfirmDeleteDialog
          open={openConfirmDeleteDialog}
          onClose={() => void onCloseConfirmDeleteDialog()}
          businessToIdentifier={businessToDelete}
          businessFromIdentifier={businessIdentifier}
        />
      )}
    </div>
  );
};

export default RelatedBusinesses;
